import Vue from 'vue'

// 千位分离器
Vue.filter('thouSeparator', (value, showZero = false) => {
  if (!value && !showZero) {
    return '--'
  }
  return value.toString().replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
})
